import ENV from 'env';
import { LatLng } from './spotSearch';

export interface MapStyleOption {
    id: string;
    label: string;
    url: string;
}

/** Basemaps drivers can switch between. All include the Streets poi_label layer the POI badges rely on. */
export const MAP_STYLES: MapStyleOption[] = [
    { id: 'streets-v12', label: 'Streets', url: 'mapbox://styles/mapbox/streets-v12?optimize=true' },
    {
        id: 'satellite-streets-v12',
        label: 'Satellite',
        url: 'mapbox://styles/mapbox/satellite-streets-v12?optimize=true',
    },
    { id: 'light-v11', label: 'Light', url: 'mapbox://styles/mapbox/light-v11?optimize=true' },
    { id: 'navigation-day-v1', label: 'Navigation', url: 'mapbox://styles/mapbox/navigation-day-v1?optimize=true' },
];

export const DEFAULT_MAP_STYLE = MAP_STYLES[0];

const PREVIEW_SIZE = 96;

/** A thumbnail of the given style's tiles around `center`, from the Static Images API. */
export function mapStylePreviewUrl(style: MapStyleOption, center: LatLng, zoom: number): string {
    const previewZoom = Math.min(15, Math.max(9, Math.round(zoom)));
    const position = `${center.lng.toFixed(5)},${center.lat.toFixed(5)},${previewZoom},0`;
    return (
        `https://api.mapbox.com/styles/v1/mapbox/${style.id}/static/${position}/${PREVIEW_SIZE}x${PREVIEW_SIZE}@2x` +
        `?access_token=${encodeURIComponent(ENV.MAPBOX_TOKEN)}&attribution=false&logo=false`
    );
}
